import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { JhiLanguageService, DataUtils } from 'ng-jhipster';
import { ImageResource } from './image-resource.model';
import { ImageResourceService } from './image-resource.service';

@Component({
    selector: 'dcs-image-resource-detail',
    templateUrl: './image-resource-detail.component.html'
})
export class ImageResourceDetailComponent implements OnInit, OnDestroy {

    imageResource: ImageResource;
    private subscription: any;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private dataUtils: DataUtils,
        private imageResourceService: ImageResourceService,
        private route: ActivatedRoute
    ) {
        this.jhiLanguageService.setLocations(['imageResource']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe(params => {
            this.load(params['id']);
        });
    }

    load (id) {
        this.imageResourceService.find(id).subscribe(imageResource => {
            this.imageResource = imageResource;
        });
    }
    byteSize(field) {
        return this.dataUtils.byteSize(field);
    }

    openFile(contentType, field) {
        return this.dataUtils.openFile(contentType, field);
    }
    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/image-resource/image-resource-detail.component.ts